export default __webpack_public_path__ + "static/media/59_mobile.e7c1fb9a.jpg";